import { useSnapshot } from "valtio"
import {
    AgmodalStore,
  ApprovalTabStore,
  EntityV2Store,
  aguserStore,
  configStore,
  loginStore,
  routerStore,
  vehicleStore,
} from "../state/CommonState"
import { useEffect, useRef, useState } from "react"
import {
  Col12,
  Col1,
  Col2,
  Col3,
  Col4,
  Col8,
  Col7,
  Col5,
  Cols,
  Col6,
  Columns,
  Col10,
  Col11,
} from "../Controls"

import RoleUtils from "../util/RoleUtils"
import Approval_Apis from "../state/approval-api"
import EntityV2Api from "../state/entities-api"
import { ReactComponent as Loader } from "../assets/loader.svg"
import { ApprovalTab, EntityTypeV2 } from "../state/Types"


export default function EditVendorCredit(props) {
    // const User = aguserStore.aguserRec
    useSnapshot(ApprovalTabStore)
    const APP = ApprovalTabStore.ApprovalRec   
    let creditdata = APP.data?.creditDetails
    let entityId = APP.data.id.split("VENCREDIT")[0]

    const [ROLE, setROLE] = useState("")
    let [creditHistory, setCreditHistory] = useState([])
    const [approveCheckbox, setApproveCheckbox] = useState(false)
    const [approvalStatus, setApprovalStatus] = useState(null)
    const [message, setMessage] = useState("")
    const [subbtnstatus, setsubbtnstatus] = useState(false)
  

    useEffect(()=> {
        setROLE(ApprovalTabStore.ApprovalRec.userRole)
        EntityV2Api.viewEntity(entityId , async(data)=> {
        setCreditHistory(data.vendor.creditHistory)
       })
    },[])

    const handleVerifyRadioChange = (event) => {
        APP.remarks = ""
        setApprovalStatus(event.target.value)
        setApproveCheckbox(true)
        setMessage("")
    }

      const handleSubmit = async (e) => {
        setsubbtnstatus(true)
        console.log(ROLE);
          if (approvalStatus === "approve" ) {
            const chkBox = document.getElementById("approveChkbox")?.checked
            if (chkBox) {
                let dataUpdate = APP
                dataUpdate.data.creditDetails.approvedBy = loginStore.email
                dataUpdate.data.updatedBy = loginStore.email
                dataUpdate.status = "Completed"
                const updatedCreditHistory = creditHistory.map(item =>
                    item.approval === 'Pending'
                        ? {
                            ...item,
                            approval: 'Completed',
                            approvedBy: loginStore.email
                        }
                        : item
                );
                setCreditHistory(updatedCreditHistory);
                dataUpdate.creditHistory = updatedCreditHistory;
            
              await Approval_Apis.VENDORCREDITAPPROVE(dataUpdate, (d)=>{
                setsubbtnstatus(false)
                  ApprovalTabStore.ApprovalRec.set(new ApprovalTab())  
                  EntityV2Store.EntityRec.set(new EntityTypeV2())
                  AgmodalStore.pageVisible = false
                  AgmodalStore.apiCall = true
                  routerStore.creditApplicationView = "list"
              })
            } else {
              setsubbtnstatus(false)
            }
    
          } else if (approvalStatus === "reject") {
            if (APP.remarks.length < 1) {
              setsubbtnstatus(false)
              return configStore.setModalMessage("Please enter remarks , it should contain atleast 3 characters")
            }
            if (APP.remarks.trim().length < 3) {
              setsubbtnstatus(false)
              return configStore.setModalMessage("Remarks should contain atleast 3 characters")
            }

              let dataUpdate = APP
            //   dataUpdate.data.creditDetails.approvedBy = loginStore.email
              dataUpdate.data.updatedBy = loginStore.email
              dataUpdate.status = "Rejected"  
              const updatedCreditHistory = creditHistory.map(item =>
                  item.approval === 'Pending'
                      ? {
                          ...item,
                          approval: 'Rejected',
                          approvedBy: "",
                          rejectedBy : loginStore.email,
                          remarks : APP.remarks
                      }
                      : item
              );
              setCreditHistory(updatedCreditHistory);
              dataUpdate.creditHistory = updatedCreditHistory;
          
            await Approval_Apis.VENDORCREDITAPPROVE(dataUpdate, (d)=>{
              setsubbtnstatus(false)
                ApprovalTabStore.ApprovalRec.set(new ApprovalTab())  
                EntityV2Store.EntityRec.set(new EntityTypeV2())
                AgmodalStore.pageVisible = false
                AgmodalStore.apiCall = true
                routerStore.creditApplicationView = "list"
            })
          } else{
            setsubbtnstatus(false)
          }
      } 
 

    return (
      <>
      
      { <>
        <div class="main-content" style={{ zoom: "0.9" }}>
          <div className="header-wrapper">
            <div className="left-header">
              <div className="page-heading" >
  
                <span className="heading">
                 {APP.data.id}/{"Vendor Credit Approval"} 
                </span>
  
              </div>
            </div>
          </div>
         <p style={{ width : "100%" , fontSize : "24px" , marginLeft: "1%"}}>Credit Details - OLD</p>
          <section
            class="section section-padding"
            style={{ paddingTop: "0px" }}
          >
            <Cols>
              <Col7 style={{ zoom: "0.9",height:"70vh",overflowY:"scroll",display:"flex",flexWrap:"wrap" }}>
                  <div style={{width:"50%",padding:"0.75rem",margin:"0.5rem 0"}}>
                  <label style={{ color: "#000",padding:"0 0.75rem",fontWeight:600 }}>Credit Days</label>
                  <Col12 style={{border:"1px solid rgb(180 178 178)",margin:"0 0.75rem",borderRadius:"4px"}}>{creditdata?.oldCredit?.creditDays || "NA"}</Col12>
                  </div>
                  <div style={{width:"50%",padding:"0.75rem",margin:"0.5rem 0"}}>
                  <label style={{ color: "#000",padding:"0 0.75rem",fontWeight:600 }}>Currency</label>
                  <Col12 style={{border:"1px solid rgb(180 178 178)",margin:"0 0.75rem",borderRadius:"4px"}}>{creditdata?.oldCredit?.currency || "NA"}</Col12>
                  </div>
                  <div style={{width:"50%",padding:"0.75rem",margin:"0.5rem 0"}}>
                  <label style={{ color: "#000",padding:"0 0.75rem",fontWeight:600 }}>Credit Limit</label>
                  <Col12 style={{border:"1px solid rgb(180 178 178)",margin:"0 0.75rem",borderRadius:"4px"}}>{creditdata?.oldCredit?.creditLimit || "NA"}</Col12>
                  </div>
                         <p style={{ width : "100%" , fontSize : "24px" , marginLeft: "1%" , marginTop : "2%"}}>Credit Details - NEW</p>
                    <div style={{width:"50%",padding:"0.75rem",margin:"0.5rem 0"}}>
                  <label style={{ color: "#000",padding:"0 0.75rem",fontWeight:600 }}>Credit Days</label>
                  <Col12 style={{border:"1px solid rgb(180 178 178)",margin:"0 0.75rem",borderRadius:"4px"}}>{creditdata?.newCredit?.creditDays || "NA"}</Col12>
                  </div>
                  <div style={{width:"50%",padding:"0.75rem",margin:"0.5rem 0"}}>
                  <label style={{ color: "#000",padding:"0 0.75rem",fontWeight:600 }}>Currency</label>
                  <Col12 style={{border:"1px solid rgb(180 178 178)",margin:"0 0.75rem",borderRadius:"4px"}}>{creditdata?.newCredit?.currency || "NA"}</Col12>
                  </div>
                  <div style={{width:"50%",padding:"0.75rem",margin:"0.5rem 0"}}>
                  <label style={{ color: "#000",padding:"0 0.75rem",fontWeight:600 }}>Credit Limit</label>
                  <Col12 style={{border:"1px solid rgb(180 178 178)",margin:"0 0.75rem",borderRadius:"4px"}}>{creditdata?.newCredit?.creditLimit || "NA"}</Col12>
                  </div>                     
              </Col7>
              <Col5 style={{position:"relative",height:"70vh"}}>
                            <div
                              style={{
                                fontWeight: "bold",
                                color: "purple",
                                fontSize: "1.1rem",
                              }}
                              className=""
                            >
                              Credit History
                            </div>
                            <table
                              className="table is-fullwidth is-narrow timeline_table"
                              style={{ zoom: "0.8" }}
                            >
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Old Credit Limits</th>
                                  <th>New Credit Limits</th>                               
                                  <th>Updated By</th>
                                  <th>Approval Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {creditHistory?.map((r, i) => {
                                  return <>
                                    <tr key={i}>
                                      <td>{new Date(r.updatedAt).toLocaleString()}</td>
                                      <td >                                         
                                        <span><span style={{width : "70px" , display: "inline-block"  }}>Days</span>-{r.oldCredit.creditDays}</span><br/>
                                        <span><span style={{width : "70px" , display: "inline-block"  }}>Currency</span>- {r.oldCredit.currency}</span><br/>
                                        <span><span style={{width : "70px" , display: "inline-block"  }}>Limit</span>-{r.oldCredit.creditLimit}</span>                                                                            
                                      </td>
                                     <td >                                         
                                        <span><span style={{width : "70px" , display: "inline-block"  }}>Days</span>-{r.newCredit.creditDays}</span><br/>
                                        <span><span style={{width : "70px" , display: "inline-block"  }}>Currency</span>- {r.newCredit.currency}</span><br/>
                                        <span><span style={{width : "70px" , display: "inline-block"  }}>Limit</span>-{r.newCredit.creditLimit}</span>                                                                            
                                      </td>
                                      <td>{r.updatedBy}</td>
                                      <td>{r.approval}</td>
                                    </tr>
                                  </>
                                })}
                              </tbody>
                            </table>
                            <div className="approve-container">
                            {(
                          <>                           
                          
                            {((ROLE === "FINANCE" || ROLE === "Operations") && (APP.status ==="Pending")) && (
                              <div className="is-flex is-justify-content-space-between">
                                <span className="is-size-6" style={{ marginTop: "1%" }}>
                                  <div>
                                    <label>
                                      <input
                                        type="radio"
                                        className="is-size-2"
                                        name="approvalStatus"
                                        value="approve"
                                        checked={approvalStatus === "approve"}
                                        onChange={handleVerifyRadioChange}
                                      />
                                      Approve
                                    </label>
                                    <label style={{ marginLeft: "10px" }}>
                                      <input
                                        type="radio"
                                        className="is-size-2"
                                        name="approvalStatus"
                                        value="reject"
                                        checked={approvalStatus === "reject"}
                                        onChange={handleVerifyRadioChange}
                                      />
                                      Reject
                                    </label>
                                  </div>
                                </span>
                              </div>
                            )}
              
                            {approvalStatus === "reject" && (
                              <div>
                                <textarea
                                  //  id="rejectremarksid"
                                  className="px-2"
                                  rows="4"
                                  cols="50"
                                  placeholder="Enter your Remarks"
                                  value={APP.remarks}
                                  onChange={(e)=> APP.remarks= e.target.value}
                                  //onChange={approvebtnnfn}
                                  style={{ marginTop: "10px", border: "1px solid #d1d1e0" }}
                                />
                              </div>
                            )}
                            {(approvalStatus === "approve") && (
                              <div>
                                Do you want to approve? <span></span>
                                <input
                                  type="checkbox"
                                  className="is-size-2"
                                  name="approvalStatus"
                                  // value="approve"
                                  id="approveChkbox"
                                // onChange={approvebtnnfn}
                                />
                              </div>
                            )}
                          </>
                        )}
                          {(ROLE === "FINANCE" || ROLE === "Operations") && (APP.status ==="Pending") &&
                          (
                            <div>
                              <span>
                                <button
                                  className="button_cancel btn_height"
                                  style={{ marginLeft: "3px", paddingLeft: "10px" }}
                                  onClick={() => {        
                                      ApprovalTabStore.ApprovalRec.set(new ApprovalTab())                           
                                      AgmodalStore.pageVisible = false;
                                      routerStore.creditApplicationView = "list"
                                      AgmodalStore.apiCall = true;
                                  }}
                                >
                                  CANCEL
                                </button>
                                <button
                                  className="button_submit btn_height"
                                  id="approvebtnid"
                                  onClick={(e) => handleSubmit(e)}
                                  disabled={subbtnstatus}
                                >
                               {!subbtnstatus ? "SUBMIT" : <Loader className="spinner" />}
              
                                </button>
                              </span>
                            </div>
                          )
                        }
               
                            </div>                       
              
                          </Col5>
            </Cols>
          </section>
           
  
  
  
  
          <hr />
        </div>
        </>
  } </>
    )
  
  }
  

